import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import React, {ReactNode} from 'react';
import {GameInfo} from "../../../../services/games/game-info";
import {ILiveTableInfo} from "../../../../services/live-table-feeds-service/live-table-feeds.service.interface";
import {Check} from "@sparkware/app-utils";
import {VideoTileBettingRangeBox} from "../video-tile-betting-range/video-tile-betting-range.box";
import {VideoTileGameTitleBox} from "../video-tile-game-title/video-tile-game-title.box";
import {VideoTileFooterBox} from "./boxes/video-tile-footer.box";
import {CyClass} from "../../../../../common/cy-classes";
import {VideoTileFooterSectionBox} from "./boxes/video-tile-footer-section.box";
import {Button} from "../../../../basic-ui-components/button/base/button.component";
import {GameJackpotComponent} from "../../../game-jackpot/game-jackpot.component";
import {
    VideoListJackpotValueBox
} from "../../static-video-specific-components/video-list-jackpot-value/video-list-jackpot-value.box";
import {
    VideoListJackpotContainerBox
} from "../../static-video-specific-components/video-list-jackpot-container/video-list-jackpot-container.box";

export type VideoTileFooterType = "jackpot" | "bets";

export interface VideoTileFooterComponentProps {
    onClickPlay: () => void;
    gameInfo: GameInfo;
    type: VideoTileFooterType;
}

export default class VideoTileFooterComponent extends OrbitComponent<VideoTileFooterComponentProps> {

    //Information from GetLiveTables request feed, for live casino games only.
    private get _tableInfo(): ILiveTableInfo | null {
        return this.services.liveTableFeeds.getTableInfo(this.props.gameInfo.gameType);
    }

    private _renderMinMaxBet(): ReactNode {

        let minBet: number;
        let maxBet: number;

        if(Check.isNullOrUndefined(this._tableInfo?.MinBet) || Check.isNullOrUndefined(this._tableInfo?.MaxBet)){
            minBet = this.props.gameInfo.minBet;
            maxBet = this.props.gameInfo.maxBet;
        } else {
            minBet = this._tableInfo.MinBet;
            maxBet = this._tableInfo.MaxBet;
        }

        return (
            <VideoTileBettingRangeBox>
                {this.services.currency.formatMinMaxBet(minBet, maxBet)}
            </VideoTileBettingRangeBox>
        );
    }

    private _renderGameTitle(): ReactNode {

        let title = this.props.gameInfo?.title || "\xa0";

        if (this._tableInfo?.Name?.length > 0) {
            title = this._tableInfo.Name;
        }

        return (
            <VideoTileGameTitleBox>
                {title}
            </VideoTileGameTitleBox>
        );
    }

    private _renderJackpot() {
        if(!this.props.gameInfo.hasJackpot) {
            return null;
        }

        return (
            <VideoListJackpotContainerBox>
                <span>
                    {this.services.translation.translate("JACKPOT")}
                </span>
                <VideoListJackpotValueBox>
                    <GameJackpotComponent gameType={this.props.gameInfo.gameType}/>
                </VideoListJackpotValueBox>
            </VideoListJackpotContainerBox>
        );
    }

    private _renderSecondaryText() {
        switch (this.props.type) {
            case "bets":
                return this._renderMinMaxBet();
            case "jackpot":
                return this._renderJackpot();
            default:
                return null;
        }
    }

    render(): React.ReactNode {
        return (
            <VideoTileFooterBox className={CyClass("cy-orbit-swiper-streaming-tile-footer")}>
                <VideoTileFooterSectionBox width={this.services.mediaQuery.xlExact ? "55%" : "65%"}>
                    {this._renderGameTitle()}
                    {this._renderSecondaryText()}
                </VideoTileFooterSectionBox>
                <VideoTileFooterSectionBox>
                    <Button
                        preset={"secondary"}
                        fullWidth
                        sizeVariant={"small"}
                        onClick={this.props.onClickPlay}
                    >
                        {this.services.translation.translate("PLAY_NOW")}
                    </Button>
                </VideoTileFooterSectionBox>
            </VideoTileFooterBox>
        );
    }
}
